<script>
import TopNav from "./components/Layout/TopNav.vue";
import SideBar from "./components/Layout/SideBar.vue";
import NotificationsModal from "@/components/NotificationsModal/NotificationsModal.vue";
import PayDebtModal from "@/components/Modals/PayDebtModal.vue";
import { mapGetters } from "vuex";
import ModalAgrement from "@/components/Order/ModalAgrement.vue";
import NoCreditCardModal from "@/components/Modals/NoCreditCardModal.vue";
import ToastNotifications from "@/components/Order/ToastNotifications.vue";
import BillingProductsAgreement from "@/components/Modals/BillingProductsAgreement.vue";
import StationSuggestionModal from "@/components/Modals/StationSuggestionModal.vue";
import axiosInstance from "@/helpers/axios";
import setRefundPopupModel from "@/components/Modals/setRefundPopupModel.vue";
import PollPopup from "@/components/Modals/PollPopup.vue";
import ForcePasswordChangeModal from "@/components/Modals/ForcePasswordChangeModal.vue";
import { isEnforced, reminderDismissedToday } from "@/utils/passwordDeadline";

export default {
  name: "MyComponent",
  components: {
    ForcePasswordChangeModal,
    BillingProductsAgreement,
    ToastNotifications,
    NoCreditCardModal,
    ModalAgrement,
    TopNav,
    SideBar,
    NotificationsModal,
    PayDebtModal,
    setRefundPopupModel,
    StationSuggestionModal,
    PollPopup,
  },
  data() {
    return {
      pollPopup: null,
      registrationRoutes: [
        "/",
        "/home",
        "/login",
        "/signup",
        "/login-phone",
        "/login-phone?",
        "/new-password/:code",
        "/reset-password",
        "/sign-up",
        "/find-station",
        "/send-email-verification",
        "/phone-verification",
        "/complete-registration",
        "/email-verification/:id",
        "/stations",
        "/how-it-works",
        "/code-verification/:token",
        "/polls/:id",
      ],
      homeRoutes: [
        "/",
        "/how-it-works",
        "/contact",
        "/sale-example",
        "/faq",
        "/policy",
        "/return-policy",
        "/calendar",
        "/phone-verification",
        "/login-phone",
        "/login-phone?",
      ],
      showNewStationModal: false,
      stationSuggestion: null,
      showPasswordUpdated: false,
      daysOfWeek: [
        "ימי ראשון",
        "ימי שני",
        "ימי שלישי",
        "ימי רביעי",
        "ימי חמישי",
        "ימי שישי",
        "ימי שבת",
      ],
    };
  },
  mounted() {
    this.syncForcePasswordChange();
    this.showPasswordUpdatedNotice();
    this.getSiteSuggestions();
    this.fetchPoll();
    //  מדמה כאילו התקבלה הצעה מהשרת
    // this.stationSuggestion = {
    //   id: 123,
    //   name: "תחנת אלומה",
    //   address: "רחוב הדוגמה 5, פתח תקווה",
    //   parking: "חנייה חינם ליד התחנה",
    //   schedule: "שני וחמישי"
    // };
    // this.showNewStationModal = true;
  },
  methods: {
    // The login / profile answers carry user.must_change_password; the login pages
    // store that user in localStorage before navigating. A 423 from any later
    // request (main.js) opens the popup too.
    syncForcePasswordChange() {
      if (!localStorage.getItem("token")) return;
      try {
        const user = JSON.parse(localStorage.getItem("user") || "null");
        if (user && user.must_change_password) {
          // Before the deadline it is a reminder shown once a day; from then on a block.
          const deadline = user.password_change_deadline || null;
          const enforced = isEnforced(deadline);
          if (enforced || !reminderDismissedToday()) {
            this.$store.dispatch("forcePasswordChange/require", {
              enforced,
              deadline,
            });
          }
        }
      } catch (e) {
        // unreadable user blob: the API's 423 still covers it
      }
    },

    // ForcePasswordChangeModal reloads the page after saving and leaves this flag.
    showPasswordUpdatedNotice() {
      try {
        if (sessionStorage.getItem("password_updated") !== "1") return;
        sessionStorage.removeItem("password_updated");
      } catch (e) {
        return;
      }
      this.showPasswordUpdated = true;
      setTimeout(() => {
        this.showPasswordUpdated = false;
      }, 4000);
    },

    findDay(weekNumber) {
      return this.daysOfWeek[weekNumber - 1];
    },

    handleStationChange() {
      this.showNewStationModal = false;
      const siteID = this.stationSuggestion?.site.id;
      const station = this.stationSuggestion?.site.name;
      if (siteID) {
        this.$router.push({
          path: "/change-station",
          query: {
            autoStep2: "true",
            siteID: siteID,
            station: station,
          },
        });
      }
    },

    async getSiteSuggestions() {
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const response = await axiosInstance.get("/get_site_suggestions");

        if (Array.isArray(response.data) && response.data.length > 0) {
          this.stationSuggestion = response.data[0];

          // Check if user has already dismissed this station suggestion
          const dismissedKey = `station-suggestion-dismissed-${this.stationSuggestion.site.name}`;
          const isDismissed = localStorage.getItem(dismissedKey);

          if (!isDismissed) {
            this.showNewStationModal = true;
          }
        } else {
        }
      } catch (e) {
        console.error("Error feching site suggestion:", e);
      }
    },

    async fetchPoll(freshLogin = false) {
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const response = await axiosInstance.get("/polls/get_poll");
        const data = response.data;
        if (!data || !data.show) return;

        const poll = data.poll;
        if (!poll) return;

        const sessionKey = `poll-shown-${poll.id}`;
        if (freshLogin) {
          sessionStorage.removeItem(sessionKey);
        }
        if (sessionStorage.getItem(sessionKey)) return;

        const delayMs = (poll.delay_seconds ?? 0) * 1000;
        setTimeout(() => {
          this.pollPopup = {
            id: poll.id,
            popupImage: poll.popup_image ?? null,
            popupTitle: poll.popup_title ?? "",
            popupText: poll.popup_text ?? "",
            url: poll.url,
          };
        }, delayMs);
      } catch (e) {
        // Silently ignore poll fetch errors
      }
    },

    dismissPollPopup() {
      if (this.pollPopup) {
        sessionStorage.setItem(`poll-shown-${this.pollPopup.id}`, "1");
      }
      this.pollPopup = null;
    },

  },
  watch: {
    isRegistrationRoute(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.syncForcePasswordChange();
        this.fetchPoll(true);
      }
    },
  },
  computed: {
    ...mapGetters({
      showDebtsModal: "debtsModule/getModalState",
      showNoCreditCardModal: "noCreditCardModal/getModalState",
      mustChangePassword: "forcePasswordChange/isRequired",
    }),
    showAgreement() {
      return this.$store.state.order.showAgrement;
    },
    isRegistrationRoute() {
      return this.registrationRoutes.some((r) => {
        if (r.includes(":")) {
          const baseRoute = r.split(":")[0];
          return this.$route.path.startsWith(baseRoute);
        } else {
          return this.$route.path === r;
        }
      });
    },
    isHomePage() {
      return this.homeRoutes.some((r) => {
        return this.$route.path === r && !localStorage.getItem("token");
      });
    },
    isOrderPage() {
      return this.$route.name === "order";
    },
    showSetRefundPopupModel() {
      return (
        this.$store.state.user.refundToCardNoSetCount == 0 ||
        ((this.$store.state.user.refundToCard === null ||
          this.$store.state.user.refundToCard === 1) &&
          ((this.$store.state.user.refundToCardNoSetCount < 3 &&
            new Date(this.$store.state.user.time) < new Date("2025-08-01")) ||
            (this.$store.state.user.refundToCardNoSetCount < 2 &&
              new Date(this.$store.state.user.time) >= new Date("2025-08-01") &&
              this.$store.state.user.ordersCount > 2)))
      );
    },
  },
};
</script>

<template dir="rtl">
  <TopNav v-if="!isRegistrationRoute && !isHomePage"></TopNav>
  <SideBar :isRegistrationRoute="isRegistrationRoute || isHomePage"></SideBar>
  <StationSuggestionModal
    v-if="showNewStationModal && stationSuggestion"
    :station-name="stationSuggestion.site.name"
    :distribution-day="findDay(stationSuggestion.site.distribution_day)"
    :location-description="stationSuggestion.site.address_description"
    :street-address="stationSuggestion.site.g_address"
    @close="showNewStationModal = false"
    @confirm="handleStationChange"
  />

  <!--  footer - always in flow at the end of the page, and kept off the order
        page, where the cart and the product grid leave it nowhere to sit -->
  <div
    v-if="!isRegistrationRoute && !isHomePage && !isOrderPage"
    class="pl-10 pb-2 z-[200] h-fit w-full"
  >
    <div
      class="flex flex-row-reverse gap-[10px] flex-wrap text-xs text-black text-opacity-35"
    >
      <p>
        <span class=""
          ><span class="font-bold">קופי:</span>
          <a class="cursor-pointer" href="https://shteinmetz.co.il/"
            >יעל שטיינמץ</a
          >
          &תפנית</span
        >
      </p>
      <p>
        <span class=""
          ><span class="font-bold"> בניה ופיתוח מערכת: </span>
          <a class="cursor-pointer" href="https://demographic.co.il/"
            >Demographic</a
          >
        </span>
      </p>
      <p>
        <span class=""
          ><span class="font-bold">אפיון עיצוב וניהול:</span>
          <a class="cursor-pointer" href="https://studiomiroca.com/"
            >Studio Miroca</a
          >
        </span>
      </p>
    </div>
  </div>

  <!-- Modals -->
  <NotificationsModal v-if="true" />
  <modal-agrement v-if="showAgreement" />
  <PayDebtModal v-if="showDebtsModal" />
  <NoCreditCardModal v-if="showNoCreditCardModal"></NoCreditCardModal>
  <set-refund-popup-model v-if="showSetRefundPopupModel" />
  <PollPopup
    v-if="pollPopup"
    :popup-image="pollPopup.popupImage"
    :popup-title="pollPopup.popupTitle"
    :popup-text="pollPopup.popupText"
    :url="pollPopup.url"
    @dismiss="dismissPollPopup"
  />
  <ForcePasswordChangeModal v-if="mustChangePassword" />
  <div
    v-if="showPasswordUpdated"
    class="fixed bottom-6 left-1/2 -translate-x-1/2 flex flex-row items-center gap-[8px] py-3 px-4 rounded bg-success text-white text-base font-medium shadow-popup"
    style="z-index: 2001"
    role="status"
  >
    <span class="material-symbols-rounded text-[20px]" aria-hidden="true">check_circle</span>
    הסיסמה עודכנה
  </div>
</template>
